import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { EMSP_BO_CHARGING_SESSION_LIST_COLUMN_LABEL_I18N_KEY } from '../emsp-bo-charging-session-list/emsp-bo-charging-session-list.config';
import { useEmspBoChargingSessionListContext } from '../emsp-bo-charging-session.context';

export const EmspBoChargingSessionListOptionsController =
  (): React.JSX.Element => {
    const { columnOptions, setColumnOptions } =
      useEmspBoChargingSessionListContext();

    return (
      <ListOptionsFormController
        columnOptions={columnOptions}
        columnLabelMap={EMSP_BO_CHARGING_SESSION_LIST_COLUMN_LABEL_I18N_KEY}
        onChange={setColumnOptions}
      />
    );
  };
